import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const CHARACTERS_DNA2 = [
  {
    title: "Data \nengineer",
    subtitle: "Eg. Telco company",
    items: [
      "Deliver quicker insights for \nimproving customers \nexperience on data at large\n scale",
      "Codeless effort in pipeline \ndesign and processing",
      "Agile practice for data \nengineering",
    ],
    image: "characters/character_3.png",
    next: {
      label: "Data Streams demo",
      onClick: () => {
        setPreviousPage(204);
        setCurrentPage(205);
      },
      endIcon: "play",
    },
    gif: "characters/character_dna2_1.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
  },
  {
    title: "BUSINESS \nANALYST",
    subtitle: "Eg. Telco company",
    items: [
      "Accelerate the data \ntransformation process",
      "Deliver better outcomes \nwith productivity, low cost \nand high velocity",
    ],
    image: "characters/character_4.png",
    next: {
      label: "Data Streams demo",
      onClick: () => {
        setPreviousPage(204);
        setCurrentPage(211);
      },
      endIcon: "play",
    },
    gif: "characters/character_dna2_2.gif",
    gifStyle: {
      position: "relative",
      width: "260px",
      height: "349px",
      overflow: "hidden",
    },
  },
];

export const DATA_CHARACTERS_DNA2 = {
  title: "Challenges solved",
  bgImage: "DNA2/DNA2_intro_04.jpg",
  characters: CHARACTERS_DNA2,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(203),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  actions: [
    {
      label: "Data Streams demo",
      onClick: () => {
        setPreviousPage(204);
        setCurrentPage(205);
      },
      endIcon: "play",
    },
  ],
};
